/**
 * Created by jeffjing on 2017/6/11.
 */
import { getQuery, getCookie, calcBkn } from './utils';
const global = require('global');
// import {getUin} from 'js/common/helpers'
const uin = (getCookie('uin') || '').replace(/^[o0]+/i, '');
const uid = getCookie('uid');
const gc = getQuery('gc') || getQuery('gid') || getQuery('gId'); // 访问的目标群号，兼容多种形式...
const skey = getCookie('skey');
const bkn = calcBkn(skey);
const user_sig = getCookie('user_sig');
const targetUid = getQuery('target_uid') || getQuery('targetUid');
const from = getQuery('from');
const roomId =
    getQuery('roomId') ||
    getQuery('room_id') ||
    getQuery('roomid') ||
    getCookie('room_id');
const roomShowNo = getQuery('room_show_no');
const protocol = global.location ? global.location.protocol : 'http:';
// const path = protocol + '//qvideo.qq.com/mixed/m'
// const params = '?_bid=2725&_hywv=1&target_uid=' + targetUid
const anchorId = getQuery('anchorId') || getQuery('anchor_id');
const isHuayangClientDev =
    getCookie('is_huayang_client_dev') === '1' ||
    getQuery('is_huayang_client_dev') === '1';
// const isHuayangClientDev = true

export default {
    uin: uin,
    // 没有targetUid，或者cookie中的uid和url中的url相同时，是主人态
    isMaster: !targetUid || targetUid === uid,
    targetUid: targetUid,
    gc: gc,
    skey: skey,
    bkn: bkn,
    uid: uid,
    roomId: Number(roomId),
    roomShowNo: roomShowNo,
    anchorId: anchorId,
    user_sig: user_sig,
    from: from,
    // isIOS: window.mqq && mqq.iOS,
    // isQQ: /\bQQ\/([\d\.]+)/.test(navigator.userAgent),              // 判断是否在QQ环境内，手Q、pcQQ抖返回true，要区分pc、mobile需要结合平台判断。
    // isAndroid: window.mqq && mqq.android,
    isPC: global.navigator && /windows/i.test(navigator.userAgent),
    isHuayangClientDev: isHuayangClientDev, // 判断下是否在花样客户端的开发环境
    url: {
        PHOTO_PATH: protocol + '//p.qpic.cn/qlove_pic/0/{{id}}/340', // 120 340 800 0
        PHOTO_NOSIZE_PATH: protocol + '//p.qpic.cn/qlove_pic/0/{{id}}/', // 没尺寸的URL
        AVATAR_PATH: protocol + '//p.qpic.cn/qtar_pic/0/{{id}}/80', // 40 80 100 160

        // EDIT_PROFILE: path + '/edit-profile.html' + params,
        // // 用户人气榜
        // POPULARITY: path + '/popularity-list.html' + params,
        // // 用户魅力榜
        // CHARM_LIST: path + '/charm-list.html' + params,
        // // 用户粉丝列
        // FANS_LIST: path + '/fans-list.html' + params,
        // // 用户关注列表
        // FOLLOW_LIST: path + '/follow-list.html' + params,
        // // 用户勋章
        // BADGE_LIST: path + '/badges.html' + params,
        // // 爵位
        // PRIVILEGE: path + '/privilege.html' + params,
        // // 语音封面
        // VOICE_COVER: path + '/voice-cover.html' + params + '&from=profile',
        // // 余额
        // // TODO为了测试这里强制走了沙箱，发布时修改回来
        // PAY: path + '/pay.html?_bid=2725&_hywv=1&sandbox=1',
        // // 手机认证
        // VERIFY_PHONE: path + '/phone-verification.html' + params,
        // // 浏览历史
        // HISTORY: path + '/history.html?_bid=2725&_hywv=1',
        // // 升级规则
        // RULE: path + '/rule.html' + params,
        // // 分享页
        // ROOM_SHARE: path + '/room-share.html' + '?_wv=16778243&from={from}&room_id={room_id}&gc={gc}',
        // // 花样大厅
        // HALL: path + '/hall.html' + params,
        // // 交友游戏玩法插件详情页
        // DATING_GAME: path + '/dating-game.html' + params,
        // // 主播序列
        // ANCHORS_SEQUENCE: path + '/anchors-sequence.html' + params + `&room_id=${roomId}&is_administrator=`,
        // // 主播序列设置
        // ANCHORS_SETTING: path + '/anchors-setting.html' + params + `&room_id=${roomId}`
    },
};
